import React from 'react';

export const ScoreSubcomponents = ({ title, health }) => {
  const healthClassName = health === "at risk" ? "at-risk" : health;
  return (
    <div className="score-subcomponents">
      <div className="text-04-navy-blue-bold">{title}</div>
      <div className="health">
        <div className="bar-health">
          <div className={healthClassName}></div>
        </div>
        <span className={`${healthClassName}-font`}>{health}</span>
      </div>
    </div>
  )
}